import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { getBaseCurrencyByCountry } from '@/services/common.service.ts';
import { useGlobalStore } from '@/store/global';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { StateCreator } from 'zustand';

type BaseCurrencyStore = {
  baseCurrency: BaseCurrencyInterface;
  setBaseCurrency: (token: Record<string, any>) => Promise<void>;
};

export const baseCurrencyStore: StateCreator<BaseCurrencyStore, [['zustand/devtools', never]], []> = set => ({
  // @ts-ignore
  baseCurrency: {},
  setBaseCurrency: async token => {
    const user = useGlobalStore.getState().user;
    const baseCurrency = await getBaseCurrencyByCountry(user.entity.currencyCountry, token);
    set({ baseCurrency }, false, 'baseCurrency/setBaseCurrency');
  }
});

export const useBaseCurrencyStore = create<BaseCurrencyStore>()(
  devtools((...a) => baseCurrencyStore(...a), { name: 'baseCurrency' })
);
